import { surgicalAttendanceMap } from "./surgicalAttendance";
import { paginationMap } from "./pagination";
import { timestampsMap } from "./timestamps";
import { patientMap } from "./patient";

const bedTypeMap: GenericObject = {
	tipo: "name",
};

export const bedMap: GenericObject = {
	numero: "number",
	localizacao: "location",
	type: bedTypeMap,
	fullname: "fullName",
	surgical_attendance: {
		__key: "surgicalAttendance",
		...surgicalAttendanceMap,
	},
	patient: patientMap,
	...timestampsMap,
};

export const paginatedBedMap: GenericObject = {
	results: bedMap,
	...paginationMap,
};
